import React from "react";

import { faBolt, faFileTimes } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import moment from "moment";

import { nGetText } from "~/lib/utils";

import type { RowProps } from "./index";

import styles from "./ViewEvent.module.css";

type BannersProps = RowProps & {
	editClicked: () => void;
};

export default function Banners({ event, eventData, editClicked }: BannersProps) {
	if (!eventData) {
		return null;
	}

	const hasRequiredSections = eventData.requiredSectionsCount > 0;
	const hasNoAgenda =
		!eventData.note &&
		!moment(event.start).isBefore(moment()) &&
		event.attendeePersonCount &&
		event.attendeePersonCount >= 2;
	const hasBanners = hasRequiredSections || hasNoAgenda;

	if (!hasBanners) {
		return null;
	}

	return (
		<div>
			{hasRequiredSections && (
				<div className={cx(styles.banner, styles.bannerRequired)}>
					<FontAwesomeIcon icon={faBolt} />
					<div>
						You are required to add to {eventData.requiredSectionsCount}{" "}
						{nGetText(eventData.requiredSectionsCount, "section", "sections")}.
					</div>
				</div>
			)}

			{hasNoAgenda && (
				<div className={cx(styles.banner, styles.bannerNoAgenda)}>
					<FontAwesomeIcon icon={faFileTimes} />
					<div className={styles.bannerFlex}>
						<div>No agenda</div>
						{event.isOrganizer && (
							<div className={styles.bannerClickable} onClick={editClicked}>
								Reschedule?
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	);
}
